import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Swap = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.9584 27.6687C33.5764 27.2868 33.3855 26.8006 33.3855 26.2104C33.3855 25.6201 33.5764 25.134 33.9584 24.752L37.8646 20.8458H25C24.4098 20.8458 23.915 20.6461 23.5157 20.2468C23.1164 19.8475 22.9167 19.3527 22.9167 18.7625C22.9167 18.1722 23.1164 17.6774 23.5157 17.2781C23.915 16.8788 24.4098 16.6791 25 16.6791H37.8646L33.9584 12.7729C33.5764 12.3909 33.3855 11.8961 33.3855 11.2885C33.3855 10.6809 33.5764 10.1861 33.9584 9.80412C34.3403 9.42217 34.8264 9.2312 35.4167 9.2312C36.007 9.2312 36.4931 9.42217 36.875 9.80412L44.375 17.3041C44.5834 17.5125 44.7309 17.7381 44.8177 17.9812C44.9046 18.2243 44.948 18.4847 44.948 18.7625C44.948 19.0402 44.9046 19.3006 44.8177 19.5437C44.7309 19.7868 44.5834 20.0125 44.375 20.2208L36.875 27.7208C36.4931 28.1027 36.007 28.285 35.4167 28.2677C34.8264 28.2503 34.3403 28.0506 33.9584 27.6687ZM13.125 40.2208L5.62504 32.7208C5.41671 32.5125 5.26914 32.2868 5.18233 32.0437C5.09553 31.8006 5.05212 31.5402 5.05212 31.2624C5.05212 30.9847 5.09553 30.7243 5.18233 30.4812C5.26914 30.2381 5.41671 30.0125 5.62504 29.8041L13.125 22.3041C13.507 21.9222 13.9931 21.7312 14.5834 21.7312C15.1737 21.7312 15.6598 21.9222 16.0417 22.3041C16.4237 22.6861 16.6146 23.1809 16.6146 23.7885C16.6146 24.3961 16.4237 24.8909 16.0417 25.2729L12.1355 29.1791H25C25.5903 29.1791 26.0851 29.3788 26.4844 29.7781C26.8837 30.1774 27.0834 30.6722 27.0834 31.2624C27.0834 31.8527 26.8837 32.3475 26.4844 32.7468C26.0851 33.1461 25.5903 33.3458 25 33.3458H12.1355L16.0417 37.252C16.4237 37.634 16.6146 38.1201 16.6146 38.7104C16.6146 39.3006 16.4237 39.7868 16.0417 40.1687C15.6598 40.5506 15.1737 40.7503 14.5834 40.7677C13.9931 40.785 13.507 40.6027 13.125 40.2208Z"
        fill={color}
      />
    </svg>
  )
}
